export class TankTypeCheck {
    constructor() {
        this.tankTypeMsg = document.querySelector('.tank-type-message');
        this.tankTypeEl = document.querySelector('select[name="tank_type"]');
        this.ACTankType = new Autocomplete(this.tankTypeEl);
    }

    setTankTypeMessage(msg, cssClass) {
        const classes = ["is-info", "is-danger", "is-warning", "is-hidden"];
        this.tankTypeMsg.classList.remove(...classes);
        this.tankTypeMsg.classList.add(cssClass);
        this.tankTypeMsg.querySelector(".message-body").innerText = msg;
    }

    hideTankTypeMessage() {
        this.setTankTypeMessage("", "is-hidden");
    }

    // All parameters are strings. When there are multiple values (individuals), ids are separated by a comma.
    checkTankTypes(individuals, tanks, toLocation) {
        let params = {}
        if (individuals.length) {
            params.individuals = individuals;
        }
        if (tanks.length) {
            params.tanks = tanks;
        }
        if (toLocation.length) {
            params.to_location = toLocation;
        }
        if (this.tankTypeEl.value) {
            params.tank_type = this.tankTypeEl.value;
        }
        // Get the data about source tanks and target tanks
        axios.get("/autocomplete/transfer_data", { params })
            .then((result) => {
                const allowedTankTypes = result?.data?.allowed_tank_types ?? [];
                const errors = result?.data?.errors ?? [];

                // Prefilter available tank types based on allowed
                if (allowedTankTypes.length > 0) {
                    this.ACTankType.setFilters({ "id__in": allowedTankTypes.map(tt => tt.id).join(',') });
                }
                if (errors.length) {
                    this.setTankTypeMessage(errors.map(error => error.body).join(" "), "is-warning");
                } else {
                    this.hideTankTypeMessage();
                }
            })
    }
}
